import { ChangeEvent } from "react";
import { cancelOrderApi, updateCustomerEmailApi, updateOrderStatusApi } from "../api";
import { custData } from "src/shared/services/interface";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { errorHandling } from "src/shared/utils/errorHandling";

export const updateCustomerEmail = async (
  getorder: any,
  confirmemail: string,
  ordersucess: any,
  email: string,
  setAgent: Function,
  setGeterror: Function,
  orderemailmsg: Function,
  customer: custData | undefined,
) => {
  if (!getorder || !getorder.Customerid) {
    notifyError("Customer ID is missing, cannot update email.");
    return;
  }
  if (confirmemail && customer) {
    const customerData: custData = {
      Address: {
        customeraddress1: customer?.Address.customeraddress1,
        customeraddress2: customer?.Address.customeraddress2,
        customeraddress3: customer?.Address.customeraddress3,
      },
      Email: confirmemail,
      Name: customer?.Name,
      alternativenumber: customer?.alternativenumber,
      phone_number: customer?.phone_number,
    };
    try {
      await updateCustomerEmailApi(getorder.Customerid, customerData);
      setTimeout(() => {
        setAgent(false);
        if (confirmemail && ordersucess) {
          orderemailmsg(
            getorder,
            confirmemail,
            String(ordersucess.payments[0].ReceivedAmount),
            String(ordersucess.Orderid),
            ordersucess.Finalamount,
            String(ordersucess.RemainingAmount),
          );
        }
      }, 2000);
      setGeterror("");
      setAgent(false);
    } catch (err) {
      notifyError("Email already exists");
    }
  } else {
    notifyError("No email provided to update.");
  }
};

export const cancelOrder = async (orderid: string | undefined, cancelData: string, setmove: Function) => {
  try {
    await cancelOrderApi(orderid, cancelData);
    setmove("Cancelled");
    notifySuccess("Order cancelled successfully");
  } catch (err) {
    errorHandling(err);
    console.log(err);
  }
};

export const handleChange = async (orderid: string | undefined, event: ChangeEvent<HTMLSelectElement>, setmove: Function, getOrdersIn: Function) => {
  try {
    await updateOrderStatusApi(orderid, event.target.value);
    setmove(event.target.value);
    getOrdersIn();
  } catch (err) {
    console.error(err);
  }
};

export const validateAndSetEmail = (
  value: string,
  setEmail: React.Dispatch<React.SetStateAction<string>>,
  setconfirmemail: React.Dispatch<React.SetStateAction<string>>,
) => {
  const isValidEmail = (value: string): boolean => {
    if (value.trim() === "") return false;
    if (!value.includes("@")) return false;
    const validDomains = [".com", ".in", ".co"];
    const hasValidDomain = validDomains.some((domain) => value.endsWith(domain));
    return hasValidDomain;
  };
  const emails = isValidEmail(value);
  if (emails) {
    setEmail(value);
    setconfirmemail(value);
  } else {
    setEmail(value);
  }
};
